import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ResourcesPage() {
  const resources = [
    {
      id: '1',
      title: 'Complete Guide to Affiliate Marketing',
      category: 'Guide',
      description: 'Learn the fundamentals of affiliate marketing and how to build a successful business from scratch.',
      image: 'https://public.readdy.ai/ai/img_res/0f11976d5762af38c3d14e439ac3c430.jpg',
      readTime: '15 min read',
      date: 'Mar 10, 2024'
    },
    {
      id: '2',
      title: 'How to Optimize Conversion Rates',
      category: 'Tutorial',
      description: 'Proven strategies and tactics to increase your affiliate conversion rates and maximize earnings.',
      image: 'https://readdy.ai/api/search-image?query=conversion%20rate%20optimization%20dashboard%20with%20analytics%20charts%20and%20performance%20metrics%20clean%20professional%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20business%20analytics%20aesthetic&width=400&height=300&seq=res2&orientation=landscape',
      readTime: '10 min read',
      date: 'Mar 8, 2024'
    },
    {
      id: '3',
      title: 'Best Practices for Link Management',
      category: 'Best Practices',
      description: 'Organize and track your affiliate links effectively with these proven management techniques.',
      image: 'https://readdy.ai/api/search-image?query=link%20management%20system%20interface%20with%20organized%20url%20structure%20and%20tracking%20tools%20modern%20clean%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20professional%20software%20aesthetic&width=400&height=300&seq=res3&orientation=landscape',
      readTime: '8 min read',
      date: 'Mar 5, 2024'
    },
    {
      id: '4',
      title: 'Understanding Analytics & Metrics',
      category: 'Guide',
      description: 'Deep dive into affiliate marketing analytics and learn which metrics matter most for your success.',
      image: 'https://readdy.ai/api/search-image?query=business%20analytics%20dashboard%20with%20data%20visualization%20charts%20and%20key%20performance%20indicators%20professional%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20modern%20analytics%20aesthetic&width=400&height=300&seq=res4&orientation=landscape',
      readTime: '12 min read',
      date: 'Mar 3, 2024'
    },
    {
      id: '5',
      title: 'SEO for Affiliate Websites',
      category: 'Tutorial',
      description: 'Master SEO techniques to drive organic traffic to your affiliate content and increase revenue.',
      image: 'https://readdy.ai/api/search-image?query=search%20engine%20optimization%20seo%20concept%20with%20keyword%20research%20and%20ranking%20charts%20professional%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20digital%20marketing%20aesthetic&width=400&height=300&seq=res5&orientation=landscape',
      readTime: '18 min read',
      date: 'Feb 28, 2024'
    },
    {
      id: '6',
      title: 'Email Marketing for Affiliates',
      category: 'Strategy',
      description: 'Build and nurture your email list to create a sustainable affiliate marketing income stream.',
      image: 'https://readdy.ai/api/search-image?query=email%20marketing%20campaign%20interface%20with%20newsletter%20templates%20and%20subscriber%20management%20clean%20modern%20design%20on%20soft%20gradient%20background%20from%20light%20purple%20to%20white%20marketing%20tool%20aesthetic&width=400&height=300&seq=res6&orientation=landscape',
      readTime: '14 min read',
      date: 'Feb 25, 2024'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-teal-500 via-teal-600 to-cyan-600 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-6xl font-extrabold text-white mb-6">Resources & Guides</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Everything you need to succeed in affiliate marketing - guides, tutorials, and best practices
            </p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-12 bg-gray-50 sticky top-20 z-40 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-center gap-3 flex-wrap">
            {['All', 'Guide', 'Tutorial', 'Best Practices', 'Strategy'].map((cat) => (
              <button
                key={cat}
                className="px-5 py-2 bg-white text-gray-700 rounded-full text-sm font-medium hover:bg-teal-500 hover:text-white transition-all whitespace-nowrap cursor-pointer shadow-sm"
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Resources Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {resources.map((resource) => (
              <article
                key={resource.id}
                className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden group hover:-translate-y-2 cursor-pointer border border-gray-100"
              >
                <div className="relative h-56 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
                  <img
                    src={resource.image}
                    alt={resource.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4 px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-900 text-xs font-semibold rounded-full">
                    {resource.category}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-500 transition-colors">
                    {resource.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-6 leading-relaxed">{resource.description}</p>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-2 text-xs text-gray-500">
                      <i className="ri-time-line"></i>
                      <span>{resource.readTime}</span>
                    </div>
                    <div className="text-xs text-gray-500">{resource.date}</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-24 bg-gradient-to-br from-teal-500 via-teal-600 to-cyan-600 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-5xl font-extrabold text-white mb-6">Stay Updated</h2>
          <p className="text-xl text-white/90 mb-12">
            Get the latest affiliate marketing tips, guides, and resources delivered to your inbox
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-white text-sm bg-white/90 text-gray-900 placeholder-gray-500"
            />
            <button className="px-8 py-4 bg-white text-teal-600 font-bold rounded-lg hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap cursor-pointer">
              Subscribe
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}